import { Platform } from "react-native";
import colors from "./colors";

export default {
  colors: colors,
  text: {
    fontFamily: Platform.OS === "android" ? "notoserif" : "Helvetica",
  },
};
